import { type InsuranceCorporateIdentity } from "../types";

export function BKK24Logo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M63.9387 98L167.114 205H272.939L168.912 98H63.9387Z"
        fill="#FCD600"
      />
      <path
        d="M274.939 204.943V308L380.939 200.36V98L274.939 204.943Z"
        fill="#FCD600"
      />
      <path d="M273.939 308H168.939V411H273.939V308Z" fill="#FCD600" />
      <path
        d="M65.8783 261.991H76.5751V248.767H65.8783V238.024H76.5751V221.124H44V292.128H76.5751V275.228H65.8783V261.991ZM76.5751 261.991H79.6127C84.7898 261.991 87.2719 264.284 87.2719 268.456C87.2719 273.928 83.2887 275.216 78.7145 275.216H76.5751V292.116H84.2815C96.8104 292.116 109.15 284.753 109.15 270.536C109.15 260.089 103.181 255.019 96.8222 252.832C102.094 249.949 105.569 246.072 105.569 238.91C105.569 231.654 101.586 221.112 82.8986 221.112H76.5869V238.012H77.4261C81.9058 238.012 84.8843 239.3 84.8843 242.881C84.8843 247.455 82.0003 248.743 77.4261 248.743H76.5869V261.991H76.5751Z"
        fill="black"
      />
      <path
        d="M112.939 292H134.906V271.02L141.007 264.354L158.583 292H185.939L155.877 248.74L181.749 221H154.69L135.108 245.455H134.906V221H112.939V292Z"
        fill="black"
      />
      <path
        d="M185.939 292H207.614V271.02L213.618 264.354L230.95 292H257.939L228.294 248.74L253.796 221H227.112L207.813 245.455H207.614V221H185.939V292Z"
        fill="black"
      />
      <path
        d="M301.939 414V278L436.939 142V277.303L301.939 414Z"
        fill="black"
      />
      <path
        d="M384.289 270.17L403.91 249.996V218.288L348.865 272.805L345.249 284.198L306.22 284.86C306.22 284.86 334.138 266.376 345.911 255.693C366.075 237.386 350.378 218.181 334.174 213.277C292.19 200.56 260.289 215.794 260.289 215.794L251.4 240.246L254.036 241.44C254.036 241.44 269.047 227.529 296.894 232.458C311.35 235.01 310.05 246.273 302.922 252.301C283.975 268.326 228.375 306.559 228.375 306.559L228.813 308.095L338.334 308.142L345.024 289.812H399.501L392.078 308.142H403.898V270.17H384.289ZM403.922 249.996L423.542 229.822L406.877 270.17H403.922V308.142H435.657L440.976 289.812H457.961L465.75 270.395H447.442L468.824 210.204L412.526 209.767L403.91 218.299V249.996H403.922Z"
        fill="#E01F2E"
      />
    </svg>
  );
}

export const BKK24: InsuranceCorporateIdentity = {
  id: "bkk24",
  name: "BKK24",
  logo: BKK24Logo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "24",
  type: "statutory",
};
